export enum InvoicesStatusEnum {
  issued = 1,
  paid = 2,
  overdue = 3,
  written_off = 4,
  canceled = 5,
  new = 6,
}
